var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.processedHtml)?_c('div',{staticClass:"pc-content-text"},[_c('text-body-extra-small',{staticClass:"pc-content-text__text app-content-wrap",attrs:{"line-height":"multi"}},[_c(_vm.processedHtml,{tag:"component"})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }